import { useTranslation } from 'react-i18next'

import { FormInputsType } from '@pages/FormCreateOrEdit/types'

import {
  GENERATOR_INPUT_TYPE,
  TIME_LINE_OBJECT_X_CELL_BIND_TYPES,
  TIME_LINE_OBJECT_X_HEADER_BIND_TYPES,
} from '@constants'

import { useHandlers } from './useHandlers'

type UseObjectXInputsType = ReturnType<typeof useHandlers>

export const useObjectXInputs = (props: UseObjectXInputsType) => {
  const { data, state, handlers } = props

  const { t } = useTranslation()

  const { watchObjectXObject, watchObjectXColumnsObject } = state
  const {
    objectsOptions,
    objectXSelectedObjectCommandsOptions,
    objectXSelectedObjectFieldsOptions,
    objectXColumnsObjectCommandsOptions,
  } = data
  const {
    handleChangeObjectXObject,
    handleChangeObjectXCommand,
    handleChangeObjectXColumnsObject,
    handleChangeObjectXColumnsObjectCommand,
    handleChangeObjectXColumnsObjectHeaderBindType,
  } = handlers

  const objectXDataInputs: FormInputsType[] = [
    {
      name: 'objectX.object',
      autocompleteOptions: objectsOptions,
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      onChangeAutocomplete: handleChangeObjectXObject,
      rules: {
        required: true,
      },
      label: t('timeLinesCreateOrEdit.objectY.object'),
      placeholder: t('timeLinesCreateOrEdit.objectY.chooseObject'),
    },
    ...(watchObjectXObject?.id
      ? [
          {
            name: 'objectX.startDateField',
            autocompleteOptions: objectXSelectedObjectFieldsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectX.startDateField'),
            placeholder: t('timeLinesCreateOrEdit.objectX.startDateField'),
          },
          {
            name: 'objectX.endDateField',
            autocompleteOptions: objectXSelectedObjectFieldsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectX.endDateField'),
            placeholder: t('timeLinesCreateOrEdit.objectX.endDateField'),
          },
          {
            name: 'objectX.getDataCommand.name',
            autocompleteOptions: objectXSelectedObjectCommandsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectY.command'),
            placeholder: t('timeLinesCreateOrEdit.objectY.command'),
            onChangeAutocomplete: handleChangeObjectXCommand,
          },
        ]
      : []),
  ]

  const objectXCellInputs: FormInputsType[] = [
    {
      name: 'objectX.cell.bindType',
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      placeholder: t('placeholder.bindType'),
      label: t('columnInputs.bindType.label'),
      autocompleteOptions: TIME_LINE_OBJECT_X_CELL_BIND_TYPES,
    },
  ]

  const objectXLinkFirstBlockInputs: FormInputsType[] = [
    {
      name: 'objectX.object',
      autocompleteOptions: objectsOptions,
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      onChangeAutocomplete: handleChangeObjectXObject,
      rules: {
        required: true,
      },
      label: t('timeLinesCreateOrEdit.objectY.object'),
      placeholder: t('timeLinesCreateOrEdit.objectY.chooseObject'),
    },
    ...(watchObjectXObject?.id
      ? [
          {
            name: 'objectX.getDataCommand.name',
            autocompleteOptions: objectXSelectedObjectCommandsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            rules: {
              required: true,
            },
            label: t('timeLinesCreateOrEdit.objectY.command'),
            placeholder: t('timeLinesCreateOrEdit.objectY.command'),
            onChangeAutocomplete: handleChangeObjectXCommand,
          },
        ]
      : []),
  ]

  const objectXColumnsObjectInputs: FormInputsType[] = [
    {
      name: 'objectX.columnsObject.object',
      autocompleteOptions: objectsOptions,
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      onChangeAutocomplete: handleChangeObjectXColumnsObject,
      label: t('timeLinesCreateOrEdit.objectY.object'),
      placeholder: t('timeLinesCreateOrEdit.objectY.chooseObject'),
    },
    ...(watchObjectXColumnsObject?.id
      ? [
          {
            name: 'objectX.columnsObject.command.name',
            autocompleteOptions: objectXColumnsObjectCommandsOptions,
            inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
            label: t('timeLinesCreateOrEdit.objectY.command'),
            placeholder: t('timeLinesCreateOrEdit.objectY.command'),
            onChangeAutocomplete: handleChangeObjectXColumnsObjectCommand,
          },
        ]
      : []),
  ]

  const objectXColumnsObjectHeaderInputs: FormInputsType[] = watchObjectXColumnsObject?.id
    ? [
        {
          name: 'objectX.columnsObject.headerBindType',
          autocompleteOptions: TIME_LINE_OBJECT_X_HEADER_BIND_TYPES,
          inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
          label: t('timeLinesCreateOrEdit.objectX.linkDataBlock.bindType'),
          placeholder: t('placeholder.bindType'),
          onChangeAutocomplete: handleChangeObjectXColumnsObjectHeaderBindType,
        },
      ]
    : []

  return {
    objectXDataInputs,
    objectXCellInputs,
    objectXLinkFirstBlockInputs,
    objectXColumnsObjectInputs,
    objectXColumnsObjectHeaderInputs,
  }
}
